'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (_ref, _ref2) {
  var toggled = _ref.toggled,
      expanded = _ref.expanded,
      styles = _ref.styles;
  var mediaQuery = _ref2.mediaQuery,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      transitions = _ref2.transitions,
      justifyContent = _ref2.justifyContent;

  var open = expanded || toggled;

  var defaultStyles = {
    root: {
      position: 'relative'
    },

    form: _defineProperty({
      maxWidth: rhythm(32),
      padding: rhythm(0.5),
      margin: '0 auto'

    }, mediaQuery('sm'), _extends({
      display: 'flex',
      alignItems: 'center',
      flexPack: 'center'
    }, justifyContent('center'))),

    field: {
      position: 'relative',
      marginRight: rhythm(1),
      flex: 1,
      transition: transitions.easeOut
    },

    input: _extends({
      paddingTop: rhythm(0.5),
      paddingBottom: rhythm(0.5),
      fontSize: scale(2),
      opacity: 0,
      transition: transitions.easeOut
    }, open && {
      width: '100%',
      opacity: 1
    }),

    label: _extends({
      display: 'block',
      transform: 'translateY(' + rhythm(1) + ')',
      fontSize: scale(2),
      whiteSpace: 'nowrap',
      transition: transitions.easeOut
    }, open && {
      transform: 'translateY(0)',
      fontSize: scale(-1),
      marginTop: '0.6rem'
    }),

    results: {
      maxWidth: rhythm(32),
      paddingTop: rhythm(1),
      margin: '0 auto'
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/search-form/styles.js
// module id = 916
// module chunks = 0